<template>
  <FilteringFacetsCriteriaMultiSelectDefault :name="props.name" />
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    default: 'Category',
  },
});
</script>
